import { Worker } from '../../apiTypes';
import { createBatch } from '../../utils/api';

type Props = {
  worker: DbDocument<Worker>;
  cafeSlug: string;
};

export const removeWorker = async ({ worker, cafeSlug }: Props) => {
  const batch = createBatch();

  batch.delete(`cafes/${cafeSlug}/workers/${worker.id}`);

  await batch.commit();
};
